import React, { useContext } from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Context from "../context";
import Search from "../../../components/searchField";

const HeaderView = () => {
    const context = useContext(Context);

    const generateHeaderTitle = (nav_type) => {
        let headerTitle = "";
        if (nav_type === 'notpaid') {
            headerTitle = "NOT PAID";
        } else if (nav_type === 'paid') {
            headerTitle = "PAID";
        } else if (nav_type === 'indispute') {
            headerTitle = "IN DISPUTE";
        }

        return headerTitle;
    };

    return(
        <div className="row">
            <div className="col-lg-6 col-7">
                <h6 className="text-uppercase text-white text-capitalize ps-3">
                    COMPLETED JOBS - {generateHeaderTitle(context.state.nav_type)}
                </h6>
            </div>
            <div className="col-lg-6 col-5 my-auto text-end">
                <div className="row">
                    <div className="col-md-10">
                        <Search
                            onSearch = {(search_text) => {
                                context.dispatch({ type: "SET_SERACH_VALUE", search_value: search_text });
                            }}
                        />
                    </div>
                    <div className="col-md-2">
                        <div className="dropdown  pe-4">
                            <a
                                href="#"
                                className="text-white cursor-pointer"
                                onClick={() => context.dispatch({
                                    type: 'IS_SHOW_DATE_FILTER',
                                    is_show_date_filter: true
                                })}
                            >
                                <CalendarMonthIcon />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeaderView;